import api from './interceptorServices';
import { base_url } from '../config';

const api_url = `${base_url}api/registrationPriceSetup`;

export const getData = async () => {
    try {
        const response = await api.get(api_url);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const handleAddData = async (items) => {
    try {
        const existing = await getData();
        const existingMap = new Map(
            existing.map(d => [Number(d.regtype_id), d])
        );
        const results = await Promise.all(
            items.map(async (item) => {
                const regtypeId = Number(item.regtype_id);
                if (isNaN(regtypeId)) {
                    throw new Error(`Invalid regtype_id in item: ${JSON.stringify(item)}`);
                }
                const match = existingMap.get(regtypeId);
                if (match) {
                    if (!match.id) throw new Error("Match found but missing ID");
                    const itemToUpdate = { ...item, id: match.id };
                    return await updateData(itemToUpdate);
                } else {
                    return await addData([item]);
                }
            })
        );
        return results;
    } catch (error) {
        console.error('Error in handleAddData:', error);
        throw error;
    }
    // try {
    //     const existing = await getData();
    //     const existingMap = new Map(
    //         existing.map(d => [Number(d.regtype_id), d])
    //     );

    //     const results = await Promise.all(
    //         items.map(async (item) => {
    //             const regtypeId = Number(item.regtype_id);
    //             if (isNaN(regtypeId)) {
    //                 throw new Error(`Invalid regtype_id in item: ${JSON.stringify(item)}`);
    //             }

    //             const match = existingMap.get(regtypeId);
    //             if (match) {
    //                 const fieldsEqual = Object.keys(item).every(key => {
    //                     if (key === 'id') return true;
    //                     return item[key] === match[key];
    //                 });
    //                 if (fieldsEqual) {
    //                     return { skipped: true, message: `Item with regtype_id ${regtypeId} unchanged`, item };
    //                 }
    //                 if (!match.id) throw new Error("Match found but missing ID");
    //                 const itemToUpdate = { ...item, id: match.id };
    //                 return await updateData(itemToUpdate);
    //             } else {
    //                 return await addData([item]);
    //             }
    //         })
    //     );
    //     return results;
    // } catch (error) {
    //     console.error('Error in handleAddData:', error);
    //     throw error;
    // }
}

export const addData = async (data) => {
    try {
        const payload = data.map(item => ({
            early_USD: parseInt(item["early_USD"], 10),
            early_EUR: parseInt(item["early_EUR"], 10),
            mid_USD: parseInt(item["mid_USD"], 10),
            mid_EUR: parseInt(item["mid_EUR"], 10),
            final_USD: parseInt(item["final_USD"], 10),
            final_EUR: parseInt(item["final_EUR"], 10),
            regdate_id: item.regdate_id,
            regtype_id: item.regtype_id,
            reg_type_order: item.reg_type_order
        }))
        const response = await api.post(api_url, payload);
        return response.data;
    } catch (error) {
        console.error('Error adding data:', error);
        throw error;
    }
};

export const updateData = async (data) => {
    try {
        const response = await api.put(api_url, data);
        return response.data;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
};

export const deleteData = async (data) => {
    try {
        const response = await api.delete(api_url, { data });
        return response.data;
    } catch (error) {
        console.error('Error deleting data:', error);
        throw error;
    }
};
